import request from '@/utils/request'

const garbageDeliveryType = {
  name: 'garbageDeliveryType',
  state: {
    isGarbageDeliveryTypeDetailLoading: false,
    garbageDeliveryTypeDetailData: {},
    otherGarbageDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_GARBAGEDELIVERYTYPE_DETAIL_LOADING: (state, data) => {
      state.isGarbageDeliveryTypeDetailLoading = data
    },
    SET_MODULES_GARBAGEDELIVERYTYPE_DETAIL_DATA: (state, data) => {
      state.garbageDeliveryTypeDetailData = data
    },
    SET_MODULES_OTHER_DETAIL_DATA: (state, data) => {
      state.otherGarbageDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryGarbageDeliveryTypeDetailData({ commit }, id) {
      commit('SET_IS_MODULES_GARBAGEDELIVERYTYPE_DETAIL_LOADING', true)
      commit('SET_MODULES_GARBAGEDELIVERYTYPE_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/garbageDeliveryType/garbageDeliveryTypeDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_GARBAGEDELIVERYTYPE_DETAIL_LOADING', false)
          commit('SET_MODULES_GARBAGEDELIVERYTYPE_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_GARBAGEDELIVERYTYPE_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetGarbageDeliveryTypeDetailData({ commit }) {
      commit('SET_MODULES_GARBAGEDELIVERYTYPE_DETAIL_DATA', {})
    },
    setGarbageDeliveryTypeDetailData({ commit }, data) {
      commit('SET_MODULES_GARBAGEDELIVERYTYPE_DETAIL_DATA', data)
    },
    //  重置账号新增页面数据
    setOtherGarbageDetailData({ commit }, data) {
      commit('SET_MODULES_OTHER_DETAIL_DATA', data)
    },
    queryGarbageDeliveryTypeListNoPage({ commit }, type, isAll) {
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/garbageDeliveryType/garbageDeliveryTypeListNoPage',
          method: 'post',
          data: { type: type }
        }).then(response => {
          for (const item of response.data) {
            item.label = item.name
            item.value = item.id
          }
          if (isAll) {
            response.data.unshift({label: '全部', value: ''})
          }
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default garbageDeliveryType
